// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"709":"15f37bca","731":"7c0d997d","905":"1a35d965"}[chunkId] + ".chunk.js";
};